module.exports = __webpack_public_path__ + "static/media/logo.0e7d59b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 391
// module chunks = 9